import { StaticImageData } from 'next/image'

import Box, { BoxProps } from 'app/components/base/Box'
import Image from 'app/components/base/Image'
import { getStaticImageSrc } from 'app/utils/helpers/functions.helpers'

interface HeroImageProps {
  image: StaticImageData
  alt: string
  sx?: BoxProps['sx']
}

const HeroImage = ({ image, alt, sx }: HeroImageProps) => {
  const imageSrc = getStaticImageSrc(image)

  return (
    <Box
      sx={{
        display: { xs: 'none', md: 'block' },
        position: { md: 'absolute', lg: 'initial' },
        ...sx
      }}
    >
      <Image
        src={imageSrc}
        layout="intrinsic"
        sizes="384px"
        width={325}
        height={234}
        alt={alt}
        quality={70}
      />
    </Box>
  )
}

export default HeroImage
